import { graphql } from 'react-relay';

export const gqlCheckInstitutionImportStatus = graphql`
  mutation checkInstitutionImportStatusMutation($institution: Int!) {
    invsysCheckInstitutionImportStatus(institution: $institution) {
      status
    }
  }
`;
